'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleScheduleAction = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doHandleScheduleAction = doHandleScheduleAction;
exports.watchScheduleCtaSagas = watchScheduleCtaSagas;

var _effects = require('redux-saga/effects');

var _Schedules = require('derivers/Schedules');

var _Schedules2 = _interopRequireDefault(_Schedules);

var _modals = require('redux/modules/modals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doHandleScheduleAction),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchScheduleCtaSagas);

var SCHEDULE_ACTION = 'ScheduleCta/SCHEDULE_ACTION';

var handleScheduleAction = exports.handleScheduleAction = function handleScheduleAction(schedule) {
  return { type: SCHEDULE_ACTION, schedule: schedule };
};

function doHandleScheduleAction(client, _ref) {
  var schedule = _ref.schedule;
  return _regenerator2.default.wrap(function doHandleScheduleAction$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!_Schedules2.default.isTopUp(schedule)) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return (0, _effects.put)((0, _modals.showModal)('TopUpModal', { schedule: schedule }));

        case 3:
          _context.next = 7;
          break;

        case 5:
          _context.next = 7;
          return (0, _effects.put)((0, _modals.showModal)('LegacyReservationModal', { classId: schedule.id }));

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchScheduleCtaSagas(client) {
  return _regenerator2.default.wrap(function watchScheduleCtaSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, handleScheduleAction().type, doHandleScheduleAction, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}